<template>
  <div class="course-creater-tip">
    <img :src="lockImg" class="lock-img" />
    <template v-if="showLockTip">
      <div class="tip-title">
        <span>创建课题将会锁定</span>
        <span> {{ lockTotal.toLocaleString() }} </span>
        <span>个案例</span>
      </div>
      <div class="tip-text">
        <span>锁定之后课题案例将不能变更，请谨慎操作！</span>
      </div>
      <div class="tip-desc">
        <span>当前课题筛选的案例总数为</span>
        <span> {{ caseTotal.toLocaleString() }} </span>
        <span>个，由于您的课题数据集数量为</span>
        <span> {{ lockTotal.toLocaleString() }} </span>
        <span>个以内。锁定案例推送规则：按文书日期最近开始排序。</span>
      </div>
    </template>
    <template v-else>
      <div class="tip-title">
        <span>创建课题将会锁定当前筛选的 </span>
        <span>{{ caseTotal.toLocaleString() }}</span>
        <span> 个案例</span>
      </div>
      <div class="tip-text">
        <span>锁定之后课题案例将不能变更，请谨慎操作！</span>
      </div>
    </template>
    <div class="footer-tools">
      <el-button type="primary" @click="confirmHandle">确定课题数据</el-button>
    </div>
  </div>
</template>

<script>
import lockImg from '@/assets/img/lock.png';

export default {
  data() {
    return {
      lockImg
    };
  },
  props: {
    lockTotal: {
      type: Number,
      required: true
    },
    caseTotal: {
      type: Number,
      required: true
    }
  },
  computed: {
    showLockTip() {
      if (this.lockTotal === 0) {
        return false;
      }
      return this.lockTotal < this.caseTotal;
    }
  },
  methods: {
    confirmHandle() {
      this.$emit('confirm');
    }
  }
};
</script>

<style lang="scss" scoped>
.course-creater-tip {
  padding: 55px 60px;

  .lock-img {
    width: 38px;
  }

  .tip-title {
    font-size: 24px;
    line-height: 33px;
    color: #1991fb;
    margin-top: 10px;
  }

  .tip-text {
    font-size: 18px;
    line-height: 25px;
    color: rgba(#3d465a, 0.8);
    margin-top: 10px;
  }

  .tip-desc {
    font-size: 14px;
    line-height: 22px;
    color: #9599a5;
    margin-top: 16px;
  }
  .footer-tools {
    margin-top: 50px;
  }
}
</style>
